import { State } from 'xstate';
import { deletePaymentProfile } from './deletePaymentProfile';

type DeletePaymentProfileMachine = typeof deletePaymentProfile;
type DeletePaymentProfile = State<DeletePaymentProfileMachine['context']>;

export const getDeletePaymentProfileStatus = (
  machineState: DeletePaymentProfile
) => ({
  isLoading: machineState.matches('loading'),
  hasError: machineState.matches('error'),
});

export const getError = (machineState: DeletePaymentProfile) => {
  return {
    errorCode: machineState.context.error?.errorCode,
    subscriptions: machineState.context.error?.subscriptions,
  };
};

export const deletePaymentProfileSelectors = {
  getDeletePaymentProfileStatus,
  getError,
};
